import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  ElementRef,
  Output,
} from "@angular/core";
import {
  RecordingSource,
  RecordingSourceType,
} from "app/js/src/domain/recording-source";

@Component({
  selector: "evrideo-recording-asset-item",
  templateUrl: "./asset-item.component.html",
  styleUrls: ["./asset-item.component.scss"],
})
export class AssetItemComponent implements OnInit {
  @Input() item: RecordingSource;
  @Input() viewMode = "grid";
  @Output() createPreview = new EventEmitter<{
    type: RecordingSourceType;
    id: string;
  }>();
  @Output() createRecordingJob = new EventEmitter<{
    type: RecordingSourceType;
    id: string;
  }>();
  @Output() navigateToSchduler = new EventEmitter<string>();
  dragged = false;
  isChannel = false;
  constructor(private ref: ElementRef) {}

  ngOnInit() {
    this.ref.nativeElement.addEventListener(
      "dragstart",
      this.onDragStart.bind(this),
      false,
    );
    this.ref.nativeElement.addEventListener(
      "dragend",
      this.onDragEnd.bind(this),
      false,
    );
    this.isChannel = this.item.type === RecordingSourceType.Channel;
  }

  previewSource() {
    this.createPreview.emit({
      type: this.item.type,
      id: this.item.referenceId,
    });
  }
  gotoScheduler() {
    this.navigateToSchduler.emit(this.item.referenceId);
  }

  startRecordingSource() {
    this.createRecordingJob.emit({
      type: this.item.type,
      id: this.item.referenceId,
    });
  }

  onDragStart(event) {
    event.dataTransfer.setData(
      "text/recordingSource",
      JSON.stringify(this.item),
    );
    event.dataTransfer.dropEffect = "copy";
    this.dragged = true;
  }

  onDragEnd(event) {
    this.dragged = false;
  }
}
